export type ErrorResponse = {
    data: {
        errorCode: string
    }
}

export const getErrorCode = (error: ErrorResponse): string | undefined =>
    error?.data?.errorCode
